export enum sortList {
    CertificateNumber = 0,
    Scope = 1,
    IssueDate = 2,
    ExpirationDate = 3,
    Status = 4,
    Entity = 5
}
